import React, { FocusEventHandler, ReactNode } from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

interface Props<T extends FieldValues> {
    onSubmit?: (data: T) => void;
    onError?: (error: unknown) => void;
    methods: UseFormReturn<T>;
    onBlur?: FocusEventHandler<HTMLFormElement>;
    onChange?: FocusEventHandler<HTMLFormElement>;
    style?: React.CSSProperties;
    children?: ReactNode;
}

export const Index = <T extends FieldValues>({
    onSubmit = () => {},
    onError = () => {},
    onBlur = () => {},
    onChange = () => {},
    methods,
    style,
    children,
}: Props<T>) => {
    return (
        <FormProvider {...methods}>
            <form
                style={style}
                noValidate
                onChange={onChange}
                onBlur={onBlur}
                onSubmit={methods.handleSubmit(onSubmit, onError)}
            >
                {children}
            </form>
        </FormProvider>
    );
};

export default Index;
